export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <p className="hero__sub">
          I’m Monika, an SDET with nine years of experience across SaaS products in healthcare, media, real estate, and AI. I specialize in Playwright automation, exploratory testing, and release ownership, with enough hands-on CI/CD and product-stack experience to set things up, keep them running, and make quality visible to the team.
        </p>
        <p className="hero__sub">
          I don’t see testing as something that happens right before release. I prefer getting involved early, during requirements and ticket grooming, so teams are aligned on what they’re actually building before code reaches QA. Post-release testing matters too, because regular checks keep catching the things that slipped through and steadily move product quality in the right direction.
        </p>
        <p className="hero__sub">
          Exploratory testing is non-negotiable for me, even when automation coverage is strong. It keeps me close to the product, close to the user, and close to the kinds of issues automation usually misses.
        </p>
      </div>
    </section>
  );
}
